import React from 'react';
import { ComponentCard } from '../layout/ComponentCard';
import { Col, Label, Input, Button, FormGroup, Form } from 'reactstrap';

export const TipoMatricula = ({
  local,
  beginning,
  next,
  previous,
  empresaId,
  setSelectedOption,
  variant,
  selectedOption,
  isSede,
}) => {
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const fullName = `${local.nombre} ${local.apellidos}`;

  return (
    <Col md="12">
      <ComponentCard
        title={`Tipo de matrícula - ${empresaId}`}
        hasButton={false}
        className="clearfix"
        name={fullName}
      >
        <Form className="pt-2">
          <FormGroup className="mb-3">
            <Label>
              <Input
                type="radio"
                id="matricula-completa"
                name="tipo-matricula"
                value="1"
                onChange={handleOptionChange}
                disabled={!isSede}
              />{' '}
              Matrícula completa
            </Label>
          </FormGroup>
          <FormGroup className="mb-3">
            <Label>
              <Input
                type="radio"
                id="matricula-personalizada"
                name="tipo-matricula"
                value="2"
                onChange={handleOptionChange}
              />{' '}
              Matrícula personalizada
            </Label>
          </FormGroup>
        </Form>
        <div className="pt-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button onClick={previous}>Atrás</Button>
          <Button onClick={beginning}>
            {variant === 'portal' ? 'Volver a detalles' : 'Volver a la ficha de alumno'}
          </Button>
          <Button
            onClick={(e) => {
              e.preventDefault(); // Previene recarga
              next(0);
            }}
            disabled={!selectedOption}
            type="button"
          >
            Siguiente
          </Button>
        </div>
      </ComponentCard>
    </Col>
  );
};
